<template>
  <teleport to="body">
    <transition name="modal-fade">
      <div
        v-if="state.show"
        class="fixed inset-0 z-[10100] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm"
        @click.self="closeModal"
      >
        <div class="w-full max-w-sm bg-card rounded-2xl border border-border shadow-2xl overflow-hidden">

          <div class="w-full h-1 bg-primary"></div>

          <!-- Header -->
          <div class="px-7 pt-7 pb-5">
            <img src="/logo/applypa-logo.png" alt="Applypa" class="h-8 mx-auto mb-5" />

            <div class="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4">
              <i :class="`fas ${copy?.icon} text-primary text-xl`"></i>
            </div>

            <h2 class="text-lg font-bold text-foreground text-center leading-snug">{{ copy?.title }}</h2>
            <p class="text-sm text-muted-foreground text-center mt-1.5 leading-relaxed">{{ copy?.message }}</p>
          </div>

          <!-- Benefits -->
          <div class="px-7 py-4 border-t border-border space-y-3">
            <div
              v-for="benefit in copy?.benefits"
              :key="benefit.text"
              class="flex items-center gap-3"
            >
              <div class="w-7 h-7 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                <i :class="`fas ${benefit.icon} text-primary text-[11px]`"></i>
              </div>
              <p class="text-sm text-foreground font-medium">{{ benefit.text }}</p>
            </div>
          </div>

          <!-- CTA -->
          <div class="px-7 pt-4 pb-7 border-t border-border">
            <button
              @click="goToPlans"
              class="bg-primary hover:bg-primary/90 text-primary-foreground font-bold py-3 rounded-xl text-sm w-full transition-colors"
            >
              See Plans →
            </button>

            <div class="flex items-center justify-center gap-4 mt-3">
              <div class="flex items-center gap-1.5">
                <i class="fas fa-check text-primary text-[10px]"></i>
                <span class="text-[11px] text-muted-foreground">No credit card required</span>
              </div>
              <div class="w-px h-3 bg-border"></div>
              <div class="flex items-center gap-1.5">
                <i class="fas fa-check text-primary text-[10px]"></i>
                <span class="text-[11px] text-muted-foreground">One-time monthly payment</span>
              </div>
            </div>

            <button
              @click="closeModal"
              class="mt-3 w-full text-center text-xs text-muted-foreground hover:text-foreground transition-colors"
            >
              Not now
            </button>
          </div>

        </div>
      </div>
    </transition>
  </teleport>
</template>

<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useUpgradeModal } from '@/composables/useUpgradeModal'

const router = useRouter()
const { state, closeModal, getCopy } = useUpgradeModal()

const copy = computed(() => getCopy())

function goToPlans() {
  closeModal()
  router.push('/subscription/plans')
}
</script>

<style scoped>
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.25s ease;
}
.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}
.modal-fade-enter-active > div,
.modal-fade-leave-active > div {
  transition: transform 0.25s ease, opacity 0.25s ease;
}
.modal-fade-enter-from > div {
  transform: scale(0.97) translateY(8px);
  opacity: 0;
}
.modal-fade-leave-to > div {
  transform: scale(0.97) translateY(8px);
  opacity: 0;
}
</style>
